<template>
  <div class="details">
    <van-swipe class="my-swipe" :autoplay="7000" indicator-color="#0070FF">
      <van-swipe-item v-for="(item, i) in banner" :key="i">
        <van-image class="swiper-img" fit="cover" :src="item.ossUrl" />
      </van-swipe-item>
    </van-swipe>
    <div class="info">
      <div class="info-tab" v-if="iscoupons == 1">券</div>
      <div class="info-price">
        {{ priceType == 1 ? '' : '￥'
        }}<span>{{ priceType == 1 ? '面议' : price }}</span>
      </div>
      <div class="info-title">{{ title }}</div>
      <div class="info-type">类型：{{ type }}</div>
      <div class="info-text">服务地区：{{ address }}</div>
      <div class="info-text">服务对象：{{ obj }}</div>
      <div class="info-text">服务方式：{{ deal }}</div>
    </div>
    <div class="content">
      <div class="content-wrap">
        <div class="content-title" @click="organTap">
          <van-image
            class="content-title-icon"
            :src="require('../../../assets/coupons-icon.png')"
          />
          <div class="content-title-text">{{ entName }}</div>
        </div>
        <div class="content-main" v-html="content"></div>
      </div>
    </div>
    <div class="btn">
      <van-button type="info" @click="buyTap">立即购买</van-button>
    </div>
  </div>
</template>
<script>
import { entDetail } from '@api/market/index'
import { saveRecord, saveUVRecord } from '@api/lishui/live'
import { Toast } from 'vant'
export default {
  data() {
    return {
      banner: [],
      iscoupons: true,
      priceType: '',
      price: '', // 价格
      title: '', // 商品名
      type: '', // 类型
      address: '', // 服务地区
      obj: '', // 服务对象
      deal: '', // 服务方式
      entName: '', // 机构名
      creditCode: '',
      content: ''
    }
  },
  mounted() {
    this.getEntDetail()
  },
  methods: {
    getEntDetail() {
      entDetail({ id: this.$route.query.id }).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          this.banner = [data.img]
          this.iscoupons = data.useCoupon
          this.priceType = data.priceType
          this.price = data.price
          this.title = data.goodsName
          this.type = data.goodsTypeName
          this.address = data.serveArea || '-'
          this.obj = data.serveTargetNameStr || '-'
          this.deal = data.serveWayNameStr || '-'
          this.entName = data.entName
          this.creditCode = data.creditCode
          this.content = data.brief
        } else {
          Toast(msg)
        }
      })
    },
    // 机构详情
    organTap() {
      this.$router.push({
        path: '/market/organ?id=' + this.creditCode
      })
    },
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      saveRecord(params).then(res => {})
      saveUVRecord(params).then(res => {})
    },
    // 立即购买
    buyTap() {
      this.buriedPoint()
      this.$router.push({
        path: '/market/buy?id=' + this.$route.query.id
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.details {
  width: 100%;
  min-height: 100vh;
  background: #f7f7f7;
  padding-bottom: 50px;
  box-sizing: border-box;
}
/deep/.van-swipe {
  height: 250px;
  .van-swipe__indicator {
    height: 2px;
    width: 16px;
    border-radius: 0;
  }
  .swiper-img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
.info {
  width: 100%;
  overflow: hidden;
  background: #fff;
  margin-top: 15px;
  position: relative;
  padding: 15px 0;
  &-tab {
    padding: 6px;
    background: #ff5c2c;
    font-size: 12px;
    color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    border-bottom-right-radius: 10px;
  }
  &-price {
    font-size: 14px;
    color: #999;
    padding: 15px 25px 0;
    span {
      font-size: 18px;
      font-weight: bold;
      color: #ff5c2c;
    }
  }
  &-title {
    font-size: 16px;
    font-weight: bold;
    padding: 10px 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &-type {
    font-size: 14px;
    color: #999;
    padding: 0 25px 10px;
    border-bottom: 1px solid #eee;
  }
  &-text {
    font-size: 14px;
    color: #999;
    padding: 10px 25px 0;
  }
}
.content {
  padding: 15px;
  .content-wrap {
    background: #fff;
    border-radius: 6px;
  }
  .content-title {
    padding: 10px 15px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    &-icon {
      width: 20px;
      height: 20px;
    }
    &-text {
      font-size: 16px;
      font-weight: bold;
      margin-left: 10px;
    }
  }
  .content-main {
    padding: 15px;
    font-size: 14px;
    color: #999;
  }
}
.btn {
  padding: 10px 15px;
  background: #fff;
  position: fixed;
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
  .van-button--info {
    width: 100%;
    height: 40px;
  }
}
</style>
